import React from 'react'
import Bredcrum from '../../common/Bredcrum'
import "../../../assets/styles/booking.css"
import BookingProcess from './BookingProcess'
// import LocationSearchMap from './GoogleMapSearch'

const BookingIndex = () => {
    return (
        <>

            <Bredcrum
                heading={'Book a Lesson'}
                path={[
                    {name : 'Book a Lesson' , path : "book-a-lesson"}
                ]}
            />

            <BookingProcess />


            {/* <LocationSearchMap /> */}
        </>
    )
}

export default BookingIndex